import AccountCircleIcon from '@mui/icons-material/AccountCircle';

export default AccountCircleIcon;
